import moment from 'moment-timezone';

export const formatDateWithTime = (date: string) => {
    return moment(date).format('DD-MM-YYYY h:mma')
};

export const formatDateWithoutTime = (date: string) => {
    return moment(date).format('DD-MM-YYYY')
};
export const formatDate = (date: string) => {
    return moment(date).format('YYYY-MM-DD')
};
export const formatDateFlatpickr = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
export const formatDateOnly = (datetime) => new Date(datetime).toLocaleDateString();
export const formatTimeOnly = (datetime) => new Date(datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
export const formatDynamicDateTime = (apiDateTime, dateFormat, timeFormat, timeZone = 'UTC') => {
    if (!apiDateTime || !dateFormat || !timeFormat) {
        return "Invalid input";
    }

    const momentDateFormat = dateFormat
        .replace(/dd/g, 'DD')
        .replace(/mm/g, 'MM')
        .replace(/yyyy/g, 'YYYY')
        .replace(/yy/g, 'YY');

    let momentTimeFormat = '';
    if (timeFormat === '12hr') {
        momentTimeFormat = 'h:mm a'; // Example: 1:12 PM
    } else if (timeFormat === '24hr') {
        momentTimeFormat = 'HH:mm'; // Example: 13:12
    } else {
        return moment(apiDateTime).tz(timeZone).format(momentDateFormat);
    }

    const finalFormat = `${momentDateFormat} ${momentTimeFormat}`;
    let formattedString = moment(apiDateTime).tz(timeZone).format(finalFormat);
    // if (timeFormat === '12hr') {
    //     formattedString = formattedString.replace(/am/i, 'am').replace(/pm/i, 'pm');
    // }
    return formattedString;
};

export const formatDynamicDateOnly = (apiDateTime, dateFormat, timeZone = 'UTC') => {
    if (!apiDateTime || !dateFormat ) {
        return "Invalid input";
    }

    const momentDateFormat = dateFormat
        .replace(/dd/g, 'DD')
        .replace(/mm/g, 'MM')
        .replace(/yyyy/g, 'YYYY')
        .replace(/yy/g, 'YY');

    let momentTimeFormat = '';
    
        return moment(apiDateTime).tz(timeZone).format(momentDateFormat);
};


export const convertDateFormatToOptions = (
    formatString: string | undefined,
    timeZone: string = 'UTC'
): Intl.DateTimeFormatOptions => {
    const options: Intl.DateTimeFormatOptions = {
        timeZone: timeZone
    };

    if (!formatString) return { year: 'numeric', month: 'long', day: 'numeric', timeZone: timeZone };

    if (formatString.includes('yyyy')) options.year = 'numeric';
    else if (formatString.includes('yy')) options.year = '2-digit';

    if (formatString.includes('MMM')) options.month = 'short';
    else if (formatString.includes('mm') || formatString.includes('MM')) options.month = '2-digit';
    else if (formatString.includes('m')) options.month = 'numeric';

    if (formatString.includes('dd')) options.day = '2-digit';
    else if (formatString.includes('d')) options.day = 'numeric';

    return options;
};

export const convertTimeFormatToOptions = (
    timeFormat: string | undefined,
    timeZone: string = 'UTC'
): Intl.DateTimeFormatOptions => {
    const baseOptions: Intl.DateTimeFormatOptions = {
        hour: 'numeric',
        minute: '2-digit',
        timeZone: timeZone
    };

    if (timeFormat === '12hr') {
        return { ...baseOptions, hour12: true };
    }
    if (timeFormat === '24hr') {
        return { ...baseOptions, hour12: false };
    }

    return { ...baseOptions, hour12: true }; // Default to 12hr
};




export const formatDateTimeCustom = (
    isoDate: string,
    dateFormat: string,
    timeFormat: string,
    timeZone: string = 'UTC',
    includeDate: boolean = true
): string => {
    if (!isoDate || !dateFormat || !timeFormat) return 'Invalid Date';

    const momentDateFormat = dateFormat
        .replace(/dd/g, 'DD')
        .replace(/mm/g, 'MM')
        .replace(/MMM/g, 'MMM')
        .replace(/yyyy/g, 'YYYY')
        .replace(/yy/g, 'YY');

    const momentTimeFormat = timeFormat === '24hr' ? 'HH:mm' : 'h:mm a';

    const finalFormat = includeDate
        ? `${momentDateFormat} ${momentTimeFormat}`
        : momentTimeFormat;
    let formattedString = moment(isoDate).tz(timeZone).format(finalFormat);
    //    if (timeFormat === '12hr') {
    //         formattedString = formattedString.replace(/am/i, 'am').replace(/pm/i, 'pm');
    //     }  
    return formattedString;
};